import React from 'react'
import Classes from "../../AppointmentDetails.module.css"
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom';
import { use } from 'react';

export default function Sidebar({ activeTab, setActiveTab }) {
    const navigateTo = useNavigate();
    const {id} = useParams();

    return (
        <ul className={Classes.sidebar} >
            <li className={activeTab === "details" ? Classes.active : ""}
                onClick={() => { navigateTo(`/view-appointment/details/${id}`) }}
            >
                <h5>Details</h5>
            </li>

            <li className={activeTab === "invoices" ? Classes.active : ""}
                onClick={() => { navigateTo(`/view-appointment/invoices/${id}`) }}
            >
                <h5>Invoices</h5>
            </li>

            <li className={activeTab === "documents" ? Classes.active : ""}
                onClick={() => { navigateTo(`/view-appointment/documents/${id}`) }}
            >
                <h5>Documents</h5>
            </li>
        </ul>
    )
}
